import { transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment as env } from '../../../environments/environment';
import { Product } from '../../models/product.model';
import { FilterService } from '../../services/filter.service';
import { MediaService } from '../../services/media.service';
import { MenuService } from '../../services/menu.service';
import { ShoppingCartService } from '../../services/shoppingcart.service';
import { UserApiService } from '../../services/user-api.service';
@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
  animations: [
    trigger('blockInitialRenderAnimation', [transition(':enter', [])])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductComponent implements OnInit {

  @Input() product$: Observable<Product>;
  @Input() locale: string;
  @Input() currency: string;
  @Input() readOnly: boolean;
  @Input() cart = false;
  @Input() expandAll$: Observable<boolean>;
  totalVolume$: Observable<number>;
  opened = false;
  private isLargePackage: boolean;

  constructor(
    private shoppingCartService: ShoppingCartService,
    private menuService: MenuService,
    public mediaService: MediaService,
    public userApiService: UserApiService,
    public filterService: FilterService
  ) {
  }

  ngOnInit() {
    this.totalVolume$ = this.product$.pipe(
      tap(product => this.isLargePackage = product?.packages?.length >= env.minimumOpenPackagesForFloatingHeader),
      map(product => this.readOnly
        ? product.packages.reduce((volume, item) => volume += this.shoppingCartService.has(item) ? item.volume.value : 0, 0)
        : product.totalVolume)
    );
  }

  hasSelection(product: Product) {
    if (this.opened) {
      return false;
    }
    return product?.packages?.some(pack => this.shoppingCartService.has(pack));
  }

  panelChanged(open = true) {
    this.opened = open;
    if (this.isLargePackage) {
      this.menuService.setLargePackageOpened(open);
    }
  }
}
